import { gql } from '@apollo/client';

export const UserFragment = gql`
  fragment User on User {
    _id
    id: _id
    name
    email
    mustAcceptTermsAndConditions: mustAccepTermsAndConditions
    mustChangePassword
    personalId
    resetPasswordToken
    termsAcceptedVersion
  }
`;
